<mat-toolbar color="primary" #toolbar>
  <mat-toolbar-row>
    <div [cdkPortalOutlet]="toolbarService.toolbarLeftPortal$ | async"></div>
    <div [cdkPortalOutlet]="toolbarService.toolbarCenterPortal$ | async"></div>
  </mat-toolbar-row>
</mat-toolbar>
